import { Component } from "@angular/core";
import { VoltaCommon } from "@core/common/volta-common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ProcessesStatusComponent } from "@process-runner/components/processes-status/processes-status.component";

@Component({
    selector: 'app-status-bar',
    imports: [FontAwesomeModule, ProcessesStatusComponent],
    templateUrl: './status-bar.component.html',
    styleUrl: './status-bar.component.scss'
})
export class StatusBarComponent {
    VoltaCommon = VoltaCommon;
}
